import React from 'react';
import { useSiteConfig } from '../../GraphQl/useSiteConfig';

import { PageLink, PathLink } from '../ui/links';
import { SubscribeForm } from './subscribeForm';

import LogoIcon from '../../svg/logoalt.svg';
import OrganicLogo from '../../svg/organic.svg';

export const Footer = () => {
  const { footerNav } = useSiteConfig();
  return (
    <div className="bg-marphonaBrown text-white py-10 md:py-32 grid grid-cols-14">
      <article className="col-start-2 col-end-14 lg:col-start-3 lg:col-end-13 grid grid-cols-1 md:grid-cols-11 md:divide-dashed divide-marphonaGold md:divide-x-2 divide-y-2 md:divide-y-0 gap-y-6">
        <div className="py-4 md:pr-10 md:col-span-2">
          <LogoIcon className="w-32 mx-auto md:w-full" />
        </div>
        <div className="pt-4 md:col-span-4 md:px-5">
          <h2 className="font-display text-2xl">Stay in the loop</h2>
          <SubscribeForm />
        </div>
        <div className="pt-4 md:col-span-2 md:px-5">
          <div className="grid gap-x-2 text-base">
            {footerNav.map((item) =>
              item._type === 'pageLink' ? (
                <PageLink
                  {...item}
                  className="font-display hover:text-marphonaGold transition-colors"
                  activeClassName="text-marphonaGold"
                />
              ) : (
                <PathLink
                  {...item}
                  className="font-display hover:text-marphonaGold transition-colors"
                  activeClassName="text-marphonaGold"
                />
              )
            )}
          </div>
        </div>
        <div className="pt-4 md:col-span-2 md:px-5">
          <h2 className="font-display text-marphonaGold">Marhphona Organic Farms</h2>
          <h2 className="font-display">206 Bell road Mangatawhiri Pokeno 2471 New Zealand</h2>
        </div>
        <div className="col-span-1 pt-4 md:pl-5">
          <div className="w-16 md:w-20 mx-auto md:w-full max-w-lg">
            <OrganicLogo />
          </div>
        </div>
      </article>
    </div>
  );
};
